














import CommonBase from "./CommonBase";
import {Component, Prop} from "vue-property-decorator";
import {DateTime} from "../modules/models";

@Component
export default class DateInput extends CommonBase {
    @Prop()
    value!: DateTime;
    @Prop({default: false})
    solo!: boolean;
    @Prop({default: false})
    flat!: boolean;
    @Prop({default: false})
    required!: boolean;
    @Prop({default: null})
    max!: DateTime | null;
    @Prop({default: DateTime.minDate})
    min!: DateTime | null;

    @Prop()
    label!: string;

    get isoValue(): string | null {
        return this.value != null ? this.value.toISOWithOffset() : null;
    }
    set isoValue(isoStr: string | null) {
        if(isoStr == null) {
            this.$emit("input", null);
        } else {
            const newVal = DateTime.fromString(isoStr).toMidnight();
            if (this.value == null || newVal.millis() != this.value.millis()) {
                this.$emit("input", newVal);
            }
        }
    }
    get norValue(): string | null {
        return this.value != null ? this.value.toLocalDate() : null;
    }
    set norValue(norStr: string | null) {
        if(norStr == null) {
            this.$emit("input", null);
        } else if(norStr.length > 7) {
            try {
                // with input mask, the value is a continous string of digits
                let newVal: DateTime | null = null;
                if(norStr.length == 8) {
                    newVal = DateTime.fromNorwStyleNoDots(norStr);
                } else {
                    newVal = DateTime.fromNorwStyle(norStr);
                }
                if (newVal != null && (this.value == null || newVal.millis() != this.value.millis())) {
                    this.$emit("input", newVal);
                }
            } catch (error) {
                // Do nothing, will keep the old value
                console.info(`Invalid date input (${norStr})`, error);
            }
        }
    }

    validate(v: string) {
        if(!v) {
            if(this.required) {
                return "Må fylles ut"
            } else {
                return true;
            }
        }
        if(v.length < 8) {
            return "For få tegn inntastet (dd.mm.åååå)";
        } else if(v.length > 10) {
            return "For mange tegn inntastet (dd.mm.åååå)";
        } else {
            try {
                // with input mask, the value is a continous string of digits
                if(v.length == 10) {
                    DateTime.fromNorwStyle(v);
                } else {
                    DateTime.fromNorwStyleNoDots(v);
                }
            } catch (error) {
                // Do nothing, will keep the old value
                console.info("Could not parse date input", error);
                return "Ugyldig dato inntastet (dd.mm.åååå)";
            }
        }
        if(this.min != null && this.value.isBefore(this.min)) {
            return `Minimum tillatt verdi er ${this.min.toLocalDate()}`;
        }
        if(this.max != null && this.value.isAfter(this.max)) {
            return `Maks tillatt verdi er ${this.max.toLocalDate()}`;
        }
        return true;
    }
}
